import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link} from 'react-router-dom'

import './RecordKeeper.css';
import * as actionsCreators from  '../../../store/actions/index';
import Spinner from '../../../components/Spinner/Spinner';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import axios from '../../../http-config';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import swal from 'sweetalert';
// import { makeStyles, withStyles } from '@material-ui/core/styles';
import ReactPaginate from 'react-paginate';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell'; 
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from '@material-ui/core/MenuList';
import NativeSelect from '@material-ui/core/NativeSelect';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import Grid from '@material-ui/core/Grid';
import Popper from '@material-ui/core/Popper';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
// import DialogTitle from '@material-ui/core/DialogTitle';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment'
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import myfile from '../../../BulkLoadUploadDocument.xlsx'

import { DatePicker , MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import * as User  from '../../../config/constant';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography'
import Radio from '@material-ui/core/Radio';
import clsx from 'clsx';
import FormControl from '@material-ui/core/FormControl';
import TablePagination from '@material-ui/core/TablePagination';
import { query } from 'chartist';
import { withTranslation } from 'react-i18next';
const BootstrapInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor:"#fff",
      border: '1px solid #4CAF50',
      fontSize: 15,
      padding: '7px 26px 7px 20px',
      transition: theme.transitions.create(['border-color']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        'Open Sans',
        'sans-serif',
   
      ].join(','),
      '&:focus ': {
        borderRadius: 4,
            backgroundColor:"#fff !important"
   
      }
    },
  }))(InputBase);

  const useStyles = makeStyles({
    root: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    icon: {
      borderRadius: '50%',
      width: 16,
      height: 16,
      boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
      backgroundColor: '#f5f8fa',
      backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
      '$root.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
      },
      'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
      },
      'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
      },
    },
    checkedIcon: {
      backgroundColor: '#3dab35',
      backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
      '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""',
      },
      'input:hover ~ &': {
        backgroundColor: '#3dab35',
      },
    },
  });
  
  // Inspired by blueprintjs
  function StyledRadio(props) {
    const classes = useStyles();
  
    return (
      <Radio
        className={classes.root}
        disableRipple
        color="default"
        checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
        icon={<span className={classes.icon} />}
        {...props}
      />
    );
  }
const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    dialogPaper: {
      minHeight: '80vh',
      maxHeight: '80vh',
  },
  });
  
  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });
  
  const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);
  
 
  




class RecordKeeper extends Component {
    state = {
        activePage:0,
        sortObj : {
            key: '',
            value: ''
        },
        limit: 10,
        filter : {
            'wardNumber':'',
            'operatorName': !!this.props.location&&this.props.location.state != undefined ?this.props.location.state.operatorName:'' ,
            'truckRegistrationNumber':'',
            'propertyTypeName':'',
        },
        controls: {
            search: {
                value: ''
            }
        },
        query: '',
        currentSortId:"",
        export:true,
        filterBy:"",
        isAll:false,
        open_dialog:false,
        todate:(localStorage.getItem('roleName' ) == User.STATEDASHBOARDUSER || localStorage.getItem('roleName' ) == User.ADMIN)? !!this.props.location&&this.props.location.endDate :new Date(),
        fromdate:(localStorage.getItem('roleName' ) == User.STATEDASHBOARDUSER || localStorage.getItem('roleName' ) == User.ADMIN)? !!this.props.location&&this.props.location.startDate : new Date('01,01,2020'),
        isFilter:false,
        selectedFile:null,
        open_addRecord:false,
        open:false,
        anchorEl:null,
        placement:'',
        open_icon:false,
        anchorEl_icon:null,
        id:'',
        searchQuery:'',
        openInfo:false,
        collecton:localStorage.getItem('isZoneNotRequired'),
        operatorIds :!!this.props.location&& !!this.props.location.state? this.props.location.state.operatorIds:"",
        searchBy:'selectName',
        checkValue:false,
        selected: [],
        checkAllValue:false,
        setRowsPerPage:10,
        allcheckBox:false
       
    }

    componentDidMount() {
        let payload = {
            token: this.props.token,
            page:  1,
            limit: this.state.limit,
            sort: '',
            filter: JSON.stringify([this.state.filter]),
            query: this.state.query,
            ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
            operatorId: this.state.operatorIds,
            searchByFields : this.state.searchBy,
        }
        
        this.props.onFetchHeaders(payload);
        this.onClickApplyFilter();
        this.props.onDownloadSampleFile(); 
    }

    handlePageClick = (e) => {
        this.setState({
            activePage : e.selected
        })
        const selectedPage = e.selected;
        let payload = {
            token: this.props.token,
            page:  selectedPage + 1,
            limit: this.state.limit,
            sort: `${this.state.sortObj.key}${this.state.sortObj.value}`,
            filter: JSON.stringify([this.state.filter]),
            query: this.state.query,
            fromDate:moment(this.state.fromdate).format('MM-DD-YYYY 00:00'),
            ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
            toDate:moment(this.state.todate).format('MM-DD-YYYY 23:59'),
            operatorId: this.state.operatorIds,
            searchByFields : this.state.searchBy,
        }
        this.state.isFilter ? this.props.onFilterLoads(payload) : this.props.onFetchLoads(payload)
    };

    handleSort = (e, sortBy) => {      
        let sortObj;
        if (this.state.sortObj.key === sortBy.accessor) {
            let value = (this.state.sortObj.value === '-desc') ? '-asc' : '-desc';
            sortObj = {
                key : sortBy.accessor,
                value: value
            }
        } 
        else {
            sortObj = {
                key : sortBy.accessor,
                value: '-desc'
            }    
        }
        this.setState({ sortObj: sortObj ,currentSortId:sortBy.accessor});
        let payload = {
            token: this.props.token,
            page:  1,
            limit: this.state.limit,
            sort: `${sortObj.key}${sortObj.value}`,
            filter: JSON.stringify([this.state.filter]),
            query: this.state.query,
            fromDate:moment(this.state.fromdate).format('MM-DD-YYYY 00:00'),
            ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
            toDate:moment(this.state.todate).format('MM-DD-YYYY 23:59'),
            operatorId: this.state.operatorIds,
            searchByFields : this.state.searchBy,
        }
        this.state.isFilter ? this.props.onFilterLoads(payload) : this.props.onFetchLoads(payload)
    }

    onClickGetFilterVals = (e, colObj) => {
       if(e===undefined){
          let isAll=true
          this.setState({isAll})
       }  
      else{
          let isAll=false
          this.setState({isAll})
      }
        const updatedFilter = {
            ...this.state.filter
        }
        updatedFilter[colObj.accessor] = e;
        this.setState({ filter: updatedFilter ,filterBy: colObj.accessor});   
        let payload = {
            token: this.props.token,
            page:  1,
            limit: this.state.limit,
            sort: `${this.state.sortObj.key}${this.state.sortObj.value}`,
            filter: JSON.stringify([updatedFilter]),
            query: this.state.query,
            fromDate:moment(this.state.fromdate).format('MM-DD-YYYY 00:00'),
            ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
            toDate:moment(this.state.todate).format('MM-DD-YYYY 23:59'),
            operatorId: this.state.operatorIds,
            searchByFields : this.state.searchBy,
        }
        this.state.isFilter ? this.props.onFilterLoads(payload) : this.props.onFetchLoads(payload)
    }

    onClickSearch = (e) => {
        e.preventDefault()
        let searchVal = this.state.controls.search.value
         if (searchVal.length >= 3 || searchVal.length == 0) {
            let payload = {
                token: this.props.token,
                page:  1,
                limit: this.state.limit,
                sort: `${this.state.sortObj.key}${this.state.sortObj.value}`,
                filter: JSON.stringify([this.state.filter]),
                query: searchVal,
                fromDate:moment(this.state.fromdate).format('MM-DD-YYYY 00:00'),
                toDate:moment(this.state.todate).format('MM-DD-YYYY 23:59'),
                ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
                operatorId: this.state.operatorIds,
                searchByFields : this.state.searchBy,
            }
            this.setState({ query: searchVal });
            this.state.isFilter ? this.props.onFilterLoads(payload) : this.props.onFetchLoads(payload)
        } else {
            swal("Enter atleast 3 characters")
        }
    }
      
    onClickExport=()=>{
        // console.log( this.state.selected," this.state.selected")
        let payload = {
            token: this.props.token,
            filter: JSON.stringify([this.state.filter]),
            query: this.state.query,
            export:this.state.export,
            fromDate:this.state.isFilter?moment(this.state.fromdate).format('MM-DD-YYYY 00:00'):'',
            toDate:moment(this.state.todate).format('MM-DD-YYYY 23:59'),
            ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
            operatorId: this.state.operatorIds,
            checkboxData: this.state.selected,
        }
        this.props.onFetchExports(payload);
        this.setState({ checkAllValue:false, checkValue:false, selected:[]})
       
    }

    inputChangedHadler = (event, controlName, searchBy) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
            }
        }
        let payload = {
            token: this.props.token,
            page:  1,
            limit: this.state.limit,
            sort: `${this.state.sortObj.key}${this.state.sortObj.value}`,
            filter: JSON.stringify([this.state.filter]),
            query: updatedControls.search.value,
            fromDate:moment(this.state.fromdate).format('MM-DD-YYYY 00:00'),
            toDate:moment(this.state.todate).format('MM-DD-YYYY 23:59'),
            ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
            operatorId: this.state.operatorIds,
            searchByFields : this.state.searchBy,
        }
            this.props.onFilterLoads(payload)
            this.setState({isFilter:true})
        
        this.setState({ controls: updatedControls,searchQuery:updatedControls.search.value, query:''});
        this.state.isFilter ? this.props.onFilterLoads(payload) : this.props.onFetchLoads(payload)
        
    }

    isActionAllowed = (actionUrl = "") => {
        return ["edit", "delete"].indexOf(actionUrl) >= 0 ? true : false;
    };
    handleChange=(e)=>{
         this.setState({[e.target.name]:e.target.value})
    }
    onClickApplyFilter= ()=>{
        let payload = {
            token: this.props.token,
            page:  1,
            limit: this.state.limit,
            sort: '',
            filter: JSON.stringify([this.state.filter]),
            query: this.state.query,
            fromDate:moment(this.state.fromdate).format('MM-DD-YYYY 00:00'),
            toDate:moment(this.state.todate).format('MM-DD-YYYY 23:59'),
            ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
            operatorId: this.state.operatorIds,
            searchByFields : this.state.searchBy,
        }
        this.props.onFilterLoads(payload)
        this.setState({isFilter:true})
    }
    onClickRemoveFilter = ()=>{
        let payload = {
            token: this.props.token,
            page:  1,
            limit: this.state.limit,
            sort: '',
            filter: JSON.stringify([this.state.filter]),
            query: '',
            fromDate:moment(!!this.props.location&&this.props.location.startDate).format('MM-DD-YYYY 00:00'),
            toDate:moment(!!this.props.location && this.props.location.endDate).format('MM-DD-YYYY 23:59'),
            ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
            operatorId: this.state.operatorIds,
            searchByFields : this.state.searchBy,
        }
        this.props.onFetchLoads(payload);
        this.setState({searchQuery:'',controls:{},isFilter:false,fromdate:(localStorage.getItem('roleName' ) == User.STATEDASHBOARDUSER || localStorage.getItem('roleName' ) == User.ADMIN)? !!this.props.location&&this.props.location.startDate : new Date('01-01-2020'),
        todate:(localStorage.getItem('roleName' ) == User.STATEDASHBOARDUSER || localStorage.getItem('roleName' ) == User.ADMIN) ? !!this.props.location && this.props.location.endDate :new Date()})
    }
    setFromDate =(date)=>{
        this.setState({fromdate:date} )
    } 
    setToDate =(date)=>{
        this.setState({todate:date})
        // this.onClickApplyFilter
    }
    handleFilterDate=()=>{
        this.onClickApplyFilter()
    }
    
   onFileUpload = () => { 
        let payload = {
            token: this.props.token,
            page:  1,
            limit: this.state.limit,
            sort: '',
            filter: JSON.stringify([this.state.filter]),
            query: this.state.query,
            fromDate:moment(this.state.fromdate).format('MM-DD-YYYY 00:00'),
            ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
            toDate:moment(this.state.todate).format('MM-DD-YYYY 23:59'),
            operatorId: this.state.operatorIds,
            searchByFields : this.state.searchBy,
        }
    const formData = new FormData(); 
    formData.append( 
        "myFile", 
        this.state.selectedFile, 
        this.state.selectedFile.name 
    )
    this.props.onfetchBulkImport(payload,formData);
    this.setState({open:false})
    }
    onFileChange = (event) => {
        this.setState({ selectedFile: event.target.files[0]},()=>{
            this.onFileUpload()
        });   
    }
    handleClose = (event) => {
    this.setState({open:false})
    };
    handleClick = (newPlacement) => (event) => {
    this.setState({ anchorEl: event.currentTarget, newPlacement:newPlacement,open:!this.state.open});
    };
    handleClickMoreVertIcon=(event,id)=>{
        this.setState({open_icon:!this.state.open_icon,anchorEl_icon:event.currentTarget,id:id})
      }
      handleClickAwayBulk = () => {
        this.setState({
          open: false 
        });
      };
      handleClickAwayEdit = () => {
        this.setState({
          open_icon:false
        });
      };
  
    handleDeleteRecord = () => {
        swal({ 
                title   : "Are you sure?",
                text    : "Once data deleted, User can not recover",
                icon    : "warning",
                buttons : {
                    cancel  : 'No',
                    confirm : 'Yes'}
                })
                .then((willDelete) => {
                    if (willDelete) {
                        let payload = {
                            token: this.props.token,
                            page:  1,
                            limit: this.state.limit,
                            sort: '',
                            filter: JSON.stringify([this.state.filter]),
                            query: this.state.query,
                            id : this.state.id,
                            fromDate:moment(this.state.fromdate).format('MM-DD-YYYY 00:00'),
                            ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
                            toDate:moment(this.state.todate).format('MM-DD-YYYY 23:59'),
                            operatorId: this.state.operatorIds,
                            searchByFields : this.state.searchBy,
                        }
                    this.props.onDeleteRecords(payload,this.props)
                    this.setState({
                        activePage:0
                    })
                } 
            });
    }  
    handleClickOpen = () => {
        this.setState({openInfo:true});
    };
    handleCloseInfo = () => {
        this.setState({openInfo:false});
      };

  
      handleCheckboxClick = (event, id) => {
        event.stopPropagation();
        const statsvalue = JSON.parse(event.target.value)
  if(event.target.checked == true){
    this.setState({checkValue: true})
  }
  else{
    this.setState({checkValue: false})
  }
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        this.setState({ selected: newSelected });
      
        
    };

       handleChangeSearch=(e)=> {
           
        if(e.target.value == 'selectName'){
            let payload = {
                token: this.props.token,
                page:  1,
                limit: this.state.limit,
                sort: '',
                filter: JSON.stringify([this.state.filter]),
                query: this.state.query,
                fromDate:moment(this.state.fromdate).format('MM-DD-YYYY 00:00'),
                toDate:moment(this.state.todate).format('MM-DD-YYYY 23:59'),
                ulbId:this.props.match.params.id == 'all' ? '' : this.props.match.params.id,
                operatorId: this.state.operatorIds,
                
            }
            this.props.onFilterLoads(payload)
            this.setState({isFilter:true})
        }
        this.setState({searchBy:e.target.value, searchByFields:e.target.name })
    }
    handleClickRow=(event, ro)=>{
// console.log(event.target.checked, this.state.checkValue,"tttttttttttttt")
        let dataArr = []
        this.setState({checkAllValue:event.target.checked, checkValue:true})

        if(!!event.target&&event.target.checked === true&&ro.accessor == "checkbox"){
            !!this.props.loads&&this.props.loads.slice(this.state.activePage * this.state.setRowsPerPage, this.state.activePage * this.state.setRowsPerPage + this.state.setRowsPerPage).map(d=>{
                dataArr.push(d.id)
            })
            this.setState({selected:dataArr})
        }else if(!!event.target&&event.target.checked === false&&ro.accessor == "checkbox"){
            this.setState({selected:[], checkValue:false})
        }

    }


     handleChangeRowsPerPage = (event) => {
        this.setState({setRowsPerPage:parseInt(event.target.value, 10), activePage:0});
        
      };
       handleChangePage = (event, newPage) => {
        // setPage(newPage);
        this.setState({activePage:newPage})
      };
    // isSelected = (name) => this.state.selected.indexOf(name) !== -1;
    render() {
        const {t, i18n} = this.props
        // console.log(this.state.selected,"selected"/)
        let filterValue;
        let array1=this.props.headers.headers.slice(0,3)
        let array2=this.props.headers.headers.slice(0)
        let fixedLoads
        let loads
        if ( !this.props.loading ) {
            if (this.props.loads.length === 0) {
            fixedLoads = <h3>No Loads</h3>
            } else {
                fixedLoads = this.props.loads.map(load => (
                    <TableRow  key={load.id}>{
                        array1.map(col => {
                                return <TableCell style={{lineHeight:'56px',alignItems:'right'}} className={"white-space"} >{ load[col.accessor]}</TableCell>
                            })
                        }
                    </TableRow>
                ));
                
            }
            loads =!!this.props.loads&&this.props.loads.slice(this.state.activePage * this.state.setRowsPerPage, this.state.activePage * this.state.setRowsPerPage + this.state.setRowsPerPage).map(load => 
            {
             const id=load["id"]
             const loadId = load["loadId"]
             return<TableRow key={load.id}  style={{
                whiteSpace: 'normal',
                wordWrap: 'break-word'
            }} >
                 {array2.map(col => {
                     if(col.accessor == "checkbox"){
                        //  console.log(this.state.checkAllValue,"this.state.checkAllValue")
                        return <TableCell 
                        style={{lineHeight:'56px',alignItems:'right'}}> 
                        {!!this.state.checkAllValue&&this.state.checkAllValue == true? 
                        <div> <Checkbox
                                    style={{ color: 'green', fontFamily: 'Open sans-serif', transform: 'scale(1.2)', width: 48 }}
                                        onClick={event =>this.handleCheckboxClick(event, id)}
                                        value={this.state.checkValue}
                                        checked={this.state.checkValue}
                                     
                                    />
                                    </div>
                        :
                         <Checkbox
                        style={{ color: 'green', fontFamily: 'Open sans-serif', transform: 'scale(1.2)', width: 48 }}
                            onClick={event =>this.handleCheckboxClick(event, id)}
                            value={this.state.checkValue}
                            // checked={this.state.checkAllValue == true? this.state.checkValue: }
                         
                        />
                      }  
                     
                        </TableCell>
                     }



                        if(col.accessor == 'propertyPhoto'){
                            if(load['propertyPhoto']&&load['propertyPhoto'] != "null"){
                            // return <TableCell><img src={load['photo']} style={{height:'1%'}}/></TableCell>
                            return <TableCell style={{lineHeight:'56px',alignItems:'right'}}> <a className="email_link" href={load['propertyPhoto']} target="_blank">View</a></TableCell>
                        }
                        else{
                            return <TableCell style={{lineHeight:'56px',alignItems:'right'}}></TableCell>
                        }
                      
                    }
                    else if(col.accessor == 'ScheduledDateTime'){
                     
                        return <TableCell>{load[col.accessor] === null?'': moment(load[col.accessor]).format('DD-MMM-YYYY hh:mm a')}</TableCell>
                    }
                    // collectionDateTime
                    else if(col.accessor == 'collectionDateTime'){
                     
                        return <TableCell>{load[col.accessor] === null?'': moment(load[col.accessor]).format('DD-MMM-YYYY hh:mm a')}</TableCell>
                    }
                    
                    else{
                            return <TableCell style={{lineHeight:'56px',alignItems:'right'}} className={"white-space"}>{ load[col.accessor]}</TableCell>}
                        })
                    }
                   

                  
                </TableRow> 
             
            });
         
        }
        
        const cols =  array2.map(col => {
            if(col.accessor === "checkbox"){
                    col.header =  <div className="check-class">
                 <Checkbox 
                    style={{ color: 'white', fontFamily: 'Open sans-serif', transform: 'scale(1.2)', width: 48 }}
                    onClick={(event) => this.handleClickRow(event, col)}
                        checked={this.state.checkAllValue}
                  
                    />

                    </div> 
            }
            let filter; 
            if (col.filter === 'true') {
            filter = 
            <select 
            style={{
                width: '16px',
                borderColor:"white",
                backgroundColor: 'LightGray',
                outline:"none",
                display: "flex",
                alignItems: 'right',   
              }}
            value={filterValue}
            onChange={(e) => {
                this.onClickGetFilterVals(e.target.value || undefined, col)
            }}
            >
                <option value="">All</option>
                {col.filterKeys.map((option, i) => (
                <option key={i} value={option.key}>
                    {option.key}
                </option>
                ))}
            </select>
            }   
          
            let filter2; 
            if (col.filter === 'true') {
            filter2= 
            <select 
            style={{
                width: '16px',
                borderColor:"white",
                backgroundColor: '#3dab35',
                outline:"none",
                display: "flex",
                alignItems: 'right',   
              }}
            value={filterValue}
            onChange={(e) => {
                this.onClickGetFilterVals(e.target.value || undefined, col)
            }}
            >
              <option value="">All</option>
                {col.filterKeys.map((option, i) => (
                <option key={i} value={option.key}>
                    {option.key}
                </option>  
                ))}
            </select>
            } 
          
            return <TableCell  className={"white-space"}>
                        <div style={{
                                display: 'flex',
                                alignItems: 'start',
                                height:'3em',
                                paddingLeft:'10px',
                                paddingRight:'10px'
                            }}>
                        {this.state.filterBy===col.accessor && this.state.isAll===false? filter2 : filter} 
                        {col.header}    
                        {col.sortable == 'false' &&
                         <div onClick={(e) =>  this.handleSort(e,col)}>
                              {col.accessor == "checkbox"  ?'':
                         <div>{
                             this.state.currentSortId===col.accessor? this.state.sortObj.value ==='-asc'?(<ArrowDropDownIcon fontSize="small"/>):(<ArrowDropUpIcon fontSize="small"/>) :(<ArrowDropDownIcon fontSize="small"/>)
                         }
                         </div>  }
                     </div> 
                        }
                      
                     
                        </div> 
                    </TableCell>
            }
            )
    return (
            <div>
                <div className="dashboard_right_content">
                    <img className="dashboard_right_content_top_icon" src="images/Rectangle.svg" />
                    <div className="dashboard_right_content_top">
                   {localStorage.getItem('roleName' ) == User.STATEDASHBOARDUSER?  <h5><Link to = "/" className="email_link"><ArrowBackIosIcon></ArrowBackIosIcon></Link>{t("dataReport")}</h5>: localStorage.getItem('roleName') == User.ADMIN ? 
                   <h5><Link to = "/state-dashboard" className="email_link"><ArrowBackIosIcon></ArrowBackIosIcon></Link>{t("dataReport")}</h5> 
                   : !!this.state.operatorIds && this.state.operatorIds != ""?  <h5><Link to = "/operator-management" className="email_link"><ArrowBackIosIcon></ArrowBackIosIcon></Link>{t("dataReport")}</h5> :<h5>{t("dataReport")}</h5>} 
                    </div>
                        <div className="dashboard_right_content_top_options">
                        <div>
                        <FormControl>
                            <Select value={this.state.searchBy}
                                onChange={this.handleChangeSearch}
                                name="searchBy"
                                style={{ width: '100%' ,backgroundColor:'white', border:"1px solid #ccc", borderRadius:'5px'}}>
                                 <MenuItem value={"selectName"}>{t("selectName")}</MenuItem>
                                    <MenuItem value={"propertyName"}>{t("byPropName")}</MenuItem>
                                    <MenuItem value={"request"}>{t("byReqId")}</MenuItem>
                                
                            </Select>
                             </FormControl>
                      </div>
                            <div className="dashboard_right_content_top_search">
                                <Paper component="form">
                                    <IconButton aria-label="menu">
                                        <img src="images/search_icon.svg" />
                                    </IconButton>
                                    <InputBase value = {this.state.searchQuery} disabled={this.state.searchBy== "selectName"? true:false} onChange={(event) => this.inputChangedHadler(event, 'search',this.state.searchBy)}  placeholder={this.state.searchBy == "selectName"? "": this.state.searchBy=="propertyName"? t("propName"):  this.state.searchBy=="request"? t("reqId"):   ""} />
                                    <Button onClick={this.onClickSearch} disabled={this.state.searchBy== "selectName"? true:false} variant="contained" color="primary" type="submit">{t("search")}</Button>
                                </Paper>
                            </div>
                           
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>

                                <span style={{fontSize: 'small',fontFamily: 'Open Sans, sans-serif'}}>&nbsp;&nbsp;&nbsp;&nbsp;</span> 
                                <DatePicker
                                        variant="inline"
                                        // inputVariant="outlined"
                                        value={this.state.fromdate}  
                                        onChange={this.setFromDate}
                                        disableFuture
                                        format='dd MMM YYY'
                                        autoOk
                                        style={{width:'10%', borderBottom: 'none'}}
                                        InputProps={{ style:{fontSize:'small', padding:'4px' ,height:'35px',marginTop:'2px',color: '#3DAB35',border: '1px solid #3DAB35', 
                                        borderRadius: '4px', fontFamily: 'Open Sans, sans-serif'},disableUnderline: true}}/>
                                 <span style={{fontSize: 'small',fontFamily: 'Open Sans, sans-serif'}}>&nbsp;&nbsp;to&nbsp;&nbsp;</span> 
                                        <DatePicker
                                        variant="inline"
                                        // inputVariant="outlined"
                                        value={this.state.todate} 
                                        onChange={this.setToDate} 
                                        disableFuture
                                        minDate={this.state.fromdate}
                                        format='dd MMM YYY'
                                        autoOk
                                        style={{width:'10%'}}
                                        InputProps={{ style:{fontSize:'small', padding:'4px' ,height:'35px',marginTop:'2px',color: '#3DAB35',border: '1px solid #3DAB35', 
                                        borderRadius: '4px', fontFamily: 'Open Sans, sans-serif'}, disableUnderline: true}}/>
                               </MuiPickersUtilsProvider>   
                               
            
                            <Button onClick={this.handleFilterDate} type="submit">{t("filter")}</Button> 
                            <Button  onClick={this.onClickExport} >{t("export")}</Button>
                           
                     
                        </div>
                    </div>
                   
                    <div className=""> 
                    <Grid container direction="row">
                         <Grid items xs={12} lg={12}>
                             <div className="dashboard_listing styling-data-report">
                                 <TableContainer component={Paper} style={{paddingLeft:"0px" ,paddingRight:"15px"}}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                            {cols} 
                                            {/* {(localStorage.getItem('roleName' ) == User.STATEDASHBOARDUSER || localStorage.getItem('roleName' ) == User.ADMIN) ? '' :<TableCell style={{paddingTop:'0px'}}>Action</TableCell> } */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody> 
                                            {loads}
                                        </TableBody>
                                    </Table>
                                 </TableContainer> 
                             </div>
                         </Grid>
                     </Grid>
                    </div>
               
            <TablePagination
                    rowsPerPageOptions={[10,50,100]}
                    colSpan={3}
                    count={this.props.totalCount}
                    component="div"
                    rowsPerPage={this.state.setRowsPerPage}
                    page={this.state.activePage}
                    SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                    }}
                    labelRowsPerPage={t("rowsPerPage")}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />



            {/* <Dialog onClose={this.handleCloseInfo} aria-labelledby="customized-dialog-title" open={this.state.openInfo}  
                fullWidth={true}  maxWidth={'sm'}>
                        <DialogTitle className="border-none"  id="customized-dialog-title" onClose={this.handleCloseInfo} >
                        Mandatory Fields
                        </DialogTitle>
                        <DialogContent>
                    <div className="paramDiv" style={{display:"flex", justifyContent:"space-between", padding:" 2% 25%"}}>
                            <div >
                              <h4 style={{color: "#3DAB35", fontFamily:"Arial, Helvetica, sans-serif"}}>Fields</h4>
                              <p className="valueOf-para">1.Facility</p>
                              <p className="valueOf-para">2.Date</p>
                              <p className="valueOf-para">3.Truck</p>
                              <p className="valueOf-para">4.ULB</p>
                              <p className="valueOf-para">5.Property Type</p>
                             
                            </div>
                    </div>
                        </DialogContent>
                      </Dialog> */}
                </div>






    );
    }
}

const mapStateToProps = state => {
    let exportEnabled = state.loads.length !==0 ? false : true
    return {
        exportEnabled : exportEnabled,
        loads: state.loads.loads,
        loading: state.loads.loading,
        token: state.auth.token,
        totalCount: state.loads.totalCount,
        headers:state.headers,
        downloadSample : state.loads.configlist

    }
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchLoads: (payload) => dispatch(actionsCreators.fetchLoads(payload)),
        onFetchExports: (payload) => dispatch(actionsCreators.fetchExports(payload)),
        onFetchHeaders: (payload) => dispatch(actionsCreators.fetchHeaders(payload)),
        onFilterLoads: (payload) => dispatch(actionsCreators.filterLoads(payload)),
        onfetchBulkImport: (payload,formData) => dispatch(actionsCreators.fetchBulkImport(payload,formData)),
        onDeleteRecords :(payload,props) => dispatch(actionsCreators.deleteRecords(payload,props)),
        // OnfetchLoadsPage : (payload)=> dispatch(actionsCreators.fetchLoadsPage(payload))
        onDownloadSampleFile :()=> dispatch(actionsCreators.DownloadSampleFile()),
        FetchCollectioRequired : (payload, props)=>dispatch(actionsCreators.isCollectioRequired(payload, props))
    }
}

export default  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RecordKeeper, axios));
